import api from 'api/api'
import { toast } from "react-toastify"

export const LOADING_SERVICE_ORDERS = "[SERVICE ORDERS] LOADING SERVICE ORDERS"
export const GET_SERVICE_ORDERS = "[SERVICE ORDERS] GET SERVICE ORDERS"
export const GET_SERVICE_ORDER = "[SERVICE ORDERS] GET SERVICE ORDER"
export const CRUD_SERVICE_ORDER = "[SERVICE ORDERS] CRUD SERVICE ORDER"

export const GET_DETAILS_SERVICE_ORDER = "[SERVICE ORDERS] GET DETAIL SERVICE ORDER"
export const SAVE_DETAIL_SERVICE_ORDER = "[SERVICE ORDERS] SAVE DETAIL SERVICE ORDER"
export const UPDATE_DETAIL_SERVICE_ORDER_GROUP = "[SERVICE ORDERS] UPDATE DETAIL SERVICE ORDER GROUP"
export const UPDATE_DETAIL_SERVICE_ORDER_QUANTITY = "[SERVICE ORDERS] UPDATE DETAIL SERVICE ORDER QUANTITY"
export const DELETE_DETAIL_SERVICE_ORDER = "[SERVICE ORDERS] DELETE DETAIL SERVICE ORDER"

export const CRUD_DETAIL_SERVICE_ORDER = "[SERVICE ORDERS] CRUD DETAIL SERVICE ORDER"
export const GET_SERVICE_ORDERS_TECH = "[SERVICE ORDERS] GET SERVICE ORDERS TECH"

// ordenes de servicio

export function getServiceOrders(page = 1) {
  const request = api.get(`/ordenesservicio?page=${page}`)
  return dispatch => {
    dispatch({ type: LOADING_SERVICE_ORDERS, payload: true })
    request.then(response => {
      dispatch({ type: GET_SERVICE_ORDERS, payload: response.data })
      dispatch({ type: LOADING_SERVICE_ORDERS, payload: false })
      return
    }).catch(error => {
      dispatch({ type: LOADING_SERVICE_ORDERS, payload: false })
    })
  }
}

export function getServiceOrderById(orderId, showLoading = true) {
  const request = api.get(`/gordenservicio/${orderId}`)
  return (dispatch) => {
    dispatch({ type: GET_SERVICE_ORDER, payload: { loading: true } })
    if (showLoading) toast.info("Obteniendo orden de servicio...", { toastId: "getServiceOrderById", autoClose: false })
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        dispatch({ type: GET_SERVICE_ORDER, payload: { loading: false, data: response.data.detalles } })
        toast.dismiss("getServiceOrderById")
      } else {
        dispatch({ type: GET_SERVICE_ORDER, payload: { loading: false, data: null } })
        toast.update("getServiceOrderById", { autoClose: 4000, type: "error", render: response.data.message })
      }
      return setTimeout(() => {
        dispatch({ type: GET_SERVICE_ORDER, payload: { loading: false, data: null } })
      }, 50)
    }).catch((error) => {
      dispatch({ type: GET_SERVICE_ORDER, payload: { loading: false, data: null } })
      toast.update("getServiceOrderById", { autoClose: 4000, type: "error", render: "Error al obtener la orden de servicio" })
      console.log(error)
    })
  }
}

export function saveServiceOrder(form) {
  const request = api.post(`/rordenservicio`, form)
  return (dispatch) => {
    dispatch({ type: CRUD_SERVICE_ORDER, payload: { loading: true } })
    toast.info("Guardando orden de servicio...", { toastId: "saveServiceOrder", autoClose: false })
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        dispatch({ type: CRUD_SERVICE_ORDER, payload: { loading: false, crud: true } })
        toast.update("saveServiceOrder", { autoClose: 4000, type: "success", render: response.data.message })
      } else {
        toast.update("saveServiceOrder", { autoClose: 4000, type: "error", render: response.data.message })
      }
      return setTimeout(() => {
        dispatch({ type: CRUD_SERVICE_ORDER, payload: { loading: false, crud: false } })
      }, 50)
    }).catch((error) => {
      dispatch({ type: CRUD_SERVICE_ORDER, payload: { loading: false, crud: false } })
      toast.update("saveServiceOrder", { autoClose: 4000, type: "error", render: "Error al guardar la orden de servicio" })
      console.log(error)
    })
  }
}

export function updateServiceOrder(form) {
  const request = api.post(`/aordenservicio`, form)
  return (dispatch) => {
    dispatch({ type: CRUD_SERVICE_ORDER, payload: { loading: true } })
    toast.info("Actualizando orden de servicio...", { toastId: "updateServiceOrder", autoClose: false })
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        dispatch({ type: CRUD_SERVICE_ORDER, payload: { loading: false, crud: true } })
        toast.update("updateServiceOrder", { autoClose: 4000, type: "success", render: response.data.message })
      } else {
        toast.update("updateServiceOrder", { autoClose: 4000, type: "error", render: response.data.message })
      }
      return setTimeout(() => {
        dispatch({ type: CRUD_SERVICE_ORDER, payload: { loading: false, crud: false } })
      }, 50)
    }).catch((error) => {
      dispatch({ type: CRUD_SERVICE_ORDER, payload: { loading: false, crud: false } })
      toast.update("updateServiceOrder", { autoClose: 4000, type: "error", render: "Error al actualizar la orden de servicio" })
      console.log(error)
    })
  }
}

export function updateStatusServiceOrder(form) {
  const request = api.post(`/cordenservicio`, form)
  return (dispatch) => {
    dispatch({ type: CRUD_SERVICE_ORDER, payload: { loading: true } })
    toast.info("Actualizando estado...", { toastId: "updateStatusServiceOrder", autoClose: false })
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        dispatch({ type: CRUD_SERVICE_ORDER, payload: { loading: false, crud: true } })
        toast.update("updateStatusServiceOrder", { autoClose: 4000, type: "success", render: response.data.message })
      } else {
        toast.update("updateStatusServiceOrder", { autoClose: 4000, type: "error", render: response.data.message })
      }
      return setTimeout(() => {
        dispatch({ type: CRUD_SERVICE_ORDER, payload: { loading: false, crud: false } })
      }, 50)
    }).catch((error) => {
      dispatch({ type: CRUD_SERVICE_ORDER, payload: { loading: false, crud: false } })
      toast.update("updateStatusServiceOrder", { autoClose: 4000, type: "error", render: "Error al actualizar estado" })
      console.log(error)
    })
  }
}

export function deleteVehicleServiceOrder(form) {
  const request = api.post(`/eordenservicio`, form)
  return (dispatch) => {
    dispatch({ type: CRUD_SERVICE_ORDER, payload: { loading: true } })
    toast.info("Eliminando orden de servicio...", { toastId: "deleteVehicleServiceOrder", autoClose: false })
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        dispatch({ type: CRUD_SERVICE_ORDER, payload: { loading: false, crud: true } })
        toast.update("deleteVehicleServiceOrder", { autoClose: 4000, type: "success", render: response.data.message })
      } else {
        toast.update("deleteVehicleServiceOrder", { autoClose: 4000, type: "error", render: response.data.message })
      }
      return setTimeout(() => {
        dispatch({ type: CRUD_SERVICE_ORDER, payload: { loading: false, crud: false } })
      }, 50)
    }).catch((error) => {
      dispatch({ type: CRUD_SERVICE_ORDER, payload: { loading: false, crud: false } })
      toast.update("deleteVehicleServiceOrder", { autoClose: 4000, type: "error", render: "Error al eliminar la orden de servicio" })
      console.log(error)
    })
  }
}


// detalle orden servicio

export function getDetailsServiceOrder(serviceOrderId) {
  const request = api.get(`/dosr/${serviceOrderId}`)
  return (dispatch) => {
    dispatch({ type: GET_DETAILS_SERVICE_ORDER, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_DETAILS_SERVICE_ORDER, payload: { data: response.data.data } })
    }).catch((error) => {
      console.log(GET_DETAILS_SERVICE_ORDER, error)
    }).finally(() => {
      dispatch({ type: GET_DETAILS_SERVICE_ORDER, payload: { loading: false } })
    })
  }
}

export function saveDetailServiceOrder(data) {
  const request = api.post('/rdosr', data)
  return (dispatch) => {
    dispatch({ type: SAVE_DETAIL_SERVICE_ORDER, payload: { saving: true } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: SAVE_DETAIL_SERVICE_ORDER, payload: { saved: true } })
      toast.success(response.data.message)
    }).catch((error) => {
      console.log(SAVE_DETAIL_SERVICE_ORDER, error)
    }).finally(() => {
      dispatch({ type: SAVE_DETAIL_SERVICE_ORDER, payload: { saving: false } })
    })
  }
}

export function updateDetailServiceOrderGroup(id, group, onSuccess) {
  const request = api.patch(`/udosr/${id}/group/${group}`)
  return (dispatch) => {
    dispatch({ type: UPDATE_DETAIL_SERVICE_ORDER_GROUP, payload: { updating_id: id } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: UPDATE_DETAIL_SERVICE_ORDER_GROUP, payload: { updated_id: id } })
      if (onSuccess) onSuccess()
    }).catch((error) => {
      console.log(UPDATE_DETAIL_SERVICE_ORDER_GROUP, error)
    }).finally(() => {
      dispatch({ type: UPDATE_DETAIL_SERVICE_ORDER_GROUP, payload: { updating_id: id } })
    })
  }
}

export function updateDetailServiceOrderQuantity(id, quantity, onSuccess) {
  const request = api.patch(`/udosr/${id}/quantity/${quantity}`)
  return (dispatch) => {
    dispatch({ type: UPDATE_DETAIL_SERVICE_ORDER_QUANTITY, payload: { updating_id: id } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: UPDATE_DETAIL_SERVICE_ORDER_QUANTITY, payload: { updated_id: id } })
      if (onSuccess) onSuccess()
    }).catch((error) => {
      console.log(UPDATE_DETAIL_SERVICE_ORDER_QUANTITY, error)
    }).finally(() => {
      dispatch({ type: UPDATE_DETAIL_SERVICE_ORDER_QUANTITY, payload: { updating_id: id } })
    })
  }
}

export function deleteDetailServiceOrder(id, onSuccess) {
  const request = api.delete(`/edosr/${id}`)
  return (dispatch) => {
    dispatch({ type: DELETE_DETAIL_SERVICE_ORDER, payload: { deleting_id: id } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: DELETE_DETAIL_SERVICE_ORDER, payload: { deleted_id: id } })
      if (onSuccess) onSuccess()
    }).catch((error) => {
      console.log(DELETE_DETAIL_SERVICE_ORDER, error)
    }).finally(() => {
      dispatch({ type: DELETE_DETAIL_SERVICE_ORDER, payload: { deleting_id: id } })
    })
  }
}

export function updateStatusDetailServiceOrder(form) {
  const request = api.post(`/cdosr`, form)
  return (dispatch) => {
    dispatch({ type: CRUD_DETAIL_SERVICE_ORDER, payload: { loading: true } })
    toast.info("Actualizando estado...", { toastId: "updateStatusDetailServiceOrder", autoClose: false })
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        dispatch({ type: CRUD_DETAIL_SERVICE_ORDER, payload: { loading: false, crud: true } })
        toast.update("updateStatusDetailServiceOrder", { autoClose: 4000, type: "success", render: response.data.message })
      } else {
        toast.update("updateStatusDetailServiceOrder", { autoClose: 4000, type: "error", render: response.data.message })
      }
      return setTimeout(() => {
        dispatch({ type: CRUD_DETAIL_SERVICE_ORDER, payload: { loading: false, crud: false } })
      }, 50)
    }).catch((error) => {
      dispatch({ type: CRUD_DETAIL_SERVICE_ORDER, payload: { loading: false, crud: false } })
      toast.update("updateStatusDetailServiceOrder", { autoClose: 4000, type: "error", render: "Error al actualizar el estado" })
      console.log(error)
    })
  }
}

// ordenes tecnicos

export function getServiceOrdersTech(techId, page = 1) {
  const request = api.get(`/ordenesserviciotecnico/${techId}?page=${page}`)
  return dispatch => {
    request.then(response => {
      dispatch({ type: GET_SERVICE_ORDERS_TECH, payload: response.data })
    }).catch(error => {
      console.log(error)
    })
  }
}